import { jumpTo, appAjaxSpinner } from '../reducers/app';
import { throttle } from '../actions/Throttle';
function isSafeStringable(x) {
    if (x === null || x === undefined)
        return true;
    const t = typeof x;
    if (t === 'string' || t === 'number' || t === 'boolean' || t === 'symbol' || t === 'bigint')
        return true;
    // functions have a toString but produce source code; allow if they override toString
    if (typeof x === 'function') {
        return x.toString !== Object.prototype.toString;
    }
    // objects: check if toString is not Object.prototype.toString
    return x.toString !== Object.prototype.toString;
}
function objectToURLEncoded(element, key, parts = []) {
    if (element !== null && typeof element === 'object') {
        for (const idx in element) {
            if (!Object.prototype.hasOwnProperty.call(element, idx))
                continue;
            const value = element[idx];
            const newKey = key ? `${key}[${idx}]` : idx;
            objectToURLEncoded(value, newKey, parts);
        }
    }
    else if (key !== undefined) {
        const value = (isSafeStringable(element) && element !== null) ? String(element) : '';
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    return parts.join('&');
}
class Ajax {
    constructor(dispatch, json = false) {
        this.dispatch = dispatch;
        this.json = json;
        dispatch(appAjaxSpinner(true));
    }
    send(method, endpoint, data, success, failure) {
        let api_url;
        const dispatch = this.dispatch;
        this.dispatch(appAjaxSpinner(true));
        if (process.env.NODE_ENV !== 'production') {
            api_url = 'https://light.dev.zigo.org/api';
            //api_url = 'http://localhost:8081/api';
            //api_url = 'http://cosmo.int.zigo.org:8081/api';
        }
        else {
            api_url = '/api';
        }
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (xhr.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
                if (xhr.status == 200) {
                    try {
                        const obj = JSON.parse(xhr.responseText);
                        if (success) {
                            success(obj);
                        }
                    }
                    catch (e) {
                        if (e instanceof SyntaxError) {
                            console.log('JSON syntax error: ' + e.message);
                            if (failure) {
                                failure(xhr);
                            }
                        }
                        else {
                            dispatch(appAjaxSpinner(false));
                            throw e;
                        }
                    }
                }
                else if (xhr.status == 401) {
                    dispatch(jumpTo('/login'));
                }
                else {
                    if (failure) {
                        failure(xhr);
                    }
                }
                dispatch(appAjaxSpinner(false));
            }
        };
        xhr.open(method, api_url + endpoint, true);
        xhr.withCredentials = true;
        if (this.json) {
            xhr.setRequestHeader('Content-Type', 'application/json');
        }
        else {
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        }
        if (data !== undefined) {
            if (this.json) {
                xhr.send(JSON.stringify(data));
            }
            else {
                xhr.send(objectToURLEncoded(data));
            }
        }
        else {
            xhr.send();
        }
    }
    get(endpoint, data, success, failure) {
        this.send('GET', endpoint, data, success, failure);
    }
    post(endpoint, data, success, failure) {
        this.send('POST', endpoint, data, success, failure);
    }
    del(endpoint, data, success, failure) {
        this.send('DELETE', endpoint, data, success, failure);
    }
    throttle_post(endpoint, data, success, failure) {
        const dispatch = this.dispatch;
        dispatch(throttle(endpoint, data, success, failure));
    }
}
export default Ajax;
